import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const EmailUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // form fields
  email, onEmailChange, emailError, setEmailError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update email'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF
      type="text"
      name="email"
      label="Email"
      required={true}
      value={email}
      maxLength={254}
      onChange={onEmailChange}
      error={emailError}
      setError={setEmailError}
      autoFocus={true}
    />
  </ModalFormUI>

export default EmailUpdateModalUI
